import { ActionV2, PrefixId, ActionSummary } from "features/Resources/Shared/models";
import useSideDrawer from "hooks/useSideDrawer";

export default function useActionSideDrawer() {
  const {
    isOpen,
    onClose,
    selectedId: selectedActionPrefixId,
    expandClickHandlerByItem,
    expandClickHandlerById,
  } = useSideDrawer<ActionV2 | ActionSummary["action"], PrefixId>({
    getItemId: (action) => action?.prefixId,
  });

  return {
    isOpen,
    onClose,
    selectedActionPrefixId,
    expandClickHandlerByAction: (action: ActionV2 | ActionSummary["action"]) => expandClickHandlerByItem(action),
    expandClickHandlerByPrefixId: (prefixId: PrefixId) => expandClickHandlerById(prefixId),
  };
}
